import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PreLogService } from '../../services/pre-log.service';
import { IPreLog } from '../../interfaces/pre-log';
import { IPreLogSubmission } from '../../interfaces/pre-log-submission';
import { ConfigurationService } from '../../services/configuration.service';
import { ErrorService } from '../../services/error.service';
import { IExternalLinks } from '../../interfaces/external-links';

@Component({
    selector: 'app-pre-log-review',
    templateUrl: './pre-log-review.component.html',
    styles: [],
    standalone: false
})
export class PreLogReviewComponent implements OnInit {
  public working: boolean = false;
  public preLog: IPreLog;
  public errorMessage: string;
  public externalLinks: IExternalLinks;

  constructor(private readonly titleService: Title,
    private readonly router: Router,
    private readonly preLogService: PreLogService,
    private readonly configService: ConfigurationService,
    private readonly errorService: ErrorService) { }

  ngOnInit() {
    this.titleService.setTitle("Review Entry");

    this.preLog = this.preLogService.getCurrentPreLog();
    if (!this.preLog) {
      this.errorMessage = "Error loading Pre-Log data from session. Your session may have expired. Please refresh your browser and try again."
      return;
    }

    this.configService.getExternalLinks()
      .subscribe(
        data => this.externalLinks = data,
        error => this.errorMessage = this.errorService.getErrorMessage(error)
      );
  }

  public backToEntry(): void {
    this.router.navigate(["/pre-log"]);
  }

  public saveAndContinue(): void {
    this.working = true;
    var preLogSubmission: IPreLogSubmission = {
      barcode: this.preLog.kitBarcode,
      dateEntered: new Date(Date.UTC(this.preLog.dateEntered.year, this.preLog.dateEntered.month - 1, this.preLog.dateEntered.day)),
      enteredBy: this.preLog.enteredBy,
      agencyId: this.preLog.agencyId,
      lastName: this.preLog.lastName,
      firstName: this.preLog.firstName,
      middleInitial: this.preLog.middleInitial ? this.preLog.middleInitial : null,
      nameSuffix: this.preLog.nameSuffix ? this.preLog.nameSuffix : null,
      aliases: this.preLog.aliases,
      gender: this.preLog.genderCode,
      raceId: this.preLog.raceId,
      dateOfBirth: new Date(Date.UTC(this.preLog.dateOfBirth.year, this.preLog.dateOfBirth.month - 1, this.preLog.dateOfBirth.day)),
      ssn: this.preLog.ssn ? this.preLog.ssn : null,
      sid: this.preLog.sid ? this.preLog.sid : null,
      sourceId: this.preLog.sourceId,
      qualifyingCharge: this.preLog.qualifyingCharge,
      state: this.preLog.state ? this.preLog.state : null,
      arrestingOfficer: this.preLog.arrestingOfficer ? this.preLog.arrestingOfficer : null,
      dcn: this.preLog.dcn ? this.preLog.dcn : null,
      docNumber: this.preLog.docNumber ? this.preLog.docNumber : null,
      collectedBy: this.preLog.collectedBy,
      dateCollected: new Date(Date.UTC(this.preLog.dateCollected.year, this.preLog.dateCollected.month - 1, this.preLog.dateCollected.day))
    };

    this.preLogService.createPreLog(preLogSubmission)
      .subscribe(data => {
        this.preLog.id = data;
        this.preLogService.setCurrentPreLog(this.preLog);
        this.working = false;
        this.router.navigate(["/pre-log/ready-to-send"]);
      }, error => {
          this.errorMessage = this.errorService.getErrorMessage(error);
          this.working = false;
      });
  }
}
